<footer class="footer">
  <span class="footer__text">
    {{ translationService.translate('footer.made_with') }}
    <rt-icon name="bravos-filled" class="footer__icon" />
    {{ translationService.translate('footer.at') }}
    <a href="https://tellent.com" target="_blank" rel="noopener noreferrer" class="footer__link">
      Tellent
    </a>
  </span>
</footer>
